import { inject, observer } from "mobx-react";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { compose } from "recompose";

import { AppLogo } from "nvent-web/components/AppLogo/AppLogo";
import LinkButton from "nvent-web/components/Button/LinkButton";
import { Auth0 } from "nvent-web/services/Auth0";

import Heading from "../../components/Heading";
import { LoginFlow } from "../../stores/LoginFlow";
import { LoginForm } from "./LoginForm";
import style from "./LoginPage.module.scss";

interface LoginPageInnerProps {
  auth0: Auth0;
  login: LoginFlow;
}

const LoginPageInner: React.FC<LoginPageInnerProps> = ({ login, auth0 }) => (
  <div className={style.root}>
    <AppLogo />

    {auth0.thirdPartyCookiesBlocked && (
      <p className={style.thirdPartyCookies}>
        <FormattedMessage
          id="login.thirdPartyCookies"
          values={{
            link: (
              <a
                href="https://medium.com/@akohubteam/how-to-enable-third-party-cookies-on-your-browsers-f9a8143b8cc5"
                target="_blank"
                rel="noreferrer noopener"
              >
                <FormattedMessage id="login.thirdPartyCookies.link" />
              </a>
            ),
          }}
        />
      </p>
    )}

    <Heading
      title={<FormattedMessage id="login.callToAction" />}
      description={<FormattedMessage id="login.description" />}
    />

    <LoginForm />

    <p className={style.forgotPassword}>
      <Link to={login.locations.forgotPassword}>
        <FormattedMessage id="login.passwordResetLink" />
      </Link>
    </p>

    <p className={style.signUp}>
      <FormattedMessage id="login.signUpRedirect" />
      <LinkButton size="large" theme="secondaryRed" to="/auth/register" className={style.signUpButton} fixedWidth>
        <FormattedMessage id="signUp.callToAction" />
      </LinkButton>
    </p>
  </div>
);

export const LoginPage = compose<LoginPageInnerProps, {}>(
  inject("auth0", "login"),
  observer
)(LoginPageInner);
export default LoginPage;
